var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29409 13.71C4.3892 13.801 4.50134 13.8724 4.62409 13.92C4.74379 13.9729 4.87322 14.0002 5.00409 14.0002C5.13496 14.0002 5.26439 13.9729 5.38409 13.92C5.50684 13.8724 5.61899 13.801 5.71409 13.71L9.71409 9.71C9.90239 9.5217 10.0082 9.2663 10.0082 9C10.0082 8.7337 9.90239 8.4783 9.71409 8.29C9.52579 8.1017 9.27039 7.99591 9.00409 7.99591C8.73779 7.99591 8.4824 8.1017 8.29409 8.29L6.00409 10.59V1C6.00409 0.734784 5.89873 0.48043 5.7112 0.292893C5.52366 0.105357 5.26931 0 5.00409 0C4.73888 0 4.48452 0.105357 4.29699 0.292893C4.10945 0.48043 4.00409 0.734784 4.00409 1V10.59L1.71409 8.29C1.62085 8.19676 1.51016 8.1228 1.38834 8.07234C1.26652 8.02188 1.13595 7.99591 1.00409 7.99591C0.872233 7.99591 0.741665 8.02188 0.619843 8.07234C0.498021 8.1228 0.38733 8.19676 0.294092 8.29C0.200853 8.38324 0.126893 8.49393 0.0764322 8.61575C0.0259719 8.73757 -1.96486e-09 8.86814 0 9C1.96485e-09 9.13186 0.0259719 9.26243 0.0764322 9.38425C0.126893 9.50607 0.200853 9.61676 0.294092 9.71L4.29409 13.71Z",
    fill: "#2266EF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d28c490d.svg";
export { ForwardRef as ReactComponent };